import {
  IconBriefcase,
  IconBuilding,
  IconBuildingCommunity,
  IconCash,
  IconCurrencyRupee,
  IconFileDescription,
  IconGavel,
  IconId,
  IconIdBadge2,
  IconLayoutDashboard,
  IconLink,
  IconListDetails,
  IconMailForward,
  IconPercentage,
  IconPhoneCall,
  IconPlus,
  IconReceipt,
  IconSend2,
  IconShieldLock,
  IconTags,
  IconTemplate,
  IconUserCheck,
  IconUserCog,
  IconUserPlus,
  IconUsers,
  IconUsersGroup,
} from "@tabler/icons-react";

/** Sidebar labels — what each destination actually does. Used by layouts and matching page titles. */
export const NAV_COPY = {
  sections: {
    overview: "Overview",
    companies: "Companies",
    people: "People",
    hiring: "Hiring",
    sourcing: "Sourcing",
    marketplace: "Marketplace",
    pipeline: "Pipeline",
    team: "Team",
    company: "Company",
    finance: "Finance",
    operations: "Operations",
  },
  common: {
    dashboard: "Dashboard",
    openJobs: "Open jobs",
    candidates: "Candidates",
    submissions: "Submissions",
    disputes: "Disputes",
    payments: "Payments",
    rateCard: "Rate card",
    rateCards: "Rate cards",
    recruiters: "Recruiters",
    affiliates: "Affiliates",
    admins: "Admins",
  },
  admin: {
    clients: "Clients",
    consultancies: "Consultancies",
    clientHr: "Client HR",
    consultancyAdmins: "Consultancy admins",
    jobs: "Jobs",
    skills: "Skills catalog",
    invoices: "Invoices",
    payouts: "Payouts",
    emails: "Email campaigns",
    campaignCandidates: "Campaign candidates",
    logs: "Audit logs",
    backToClients: "Clients",
  },
  recruiter: {
    callQueue: "Call queue",
    myCandidates: "My candidates",
    addCandidate: "Add candidate",
  },
  hr: {
    postJob: "Post a job",
    editJob: "Edit job",
    jobs: "Jobs",
    hiringFlows: "Hiring flows",
    team: "Team",
  },
  consultancy: {
    recruiters: "Recruiters",
    admins: "Admins",
  },
} as const;

/** Same icons for sidebar NavLink and PageHeader so they cannot drift. */
export const NAV_ICONS = {
  dashboard: IconLayoutDashboard,
  openJobs: IconBriefcase,
  candidates: IconUsers,
  submissions: IconSend2,
  disputes: IconGavel,
  payments: IconCurrencyRupee,
  rateCard: IconPercentage,
  rateCards: IconFileDescription,
  recruiters: IconUserCheck,
  affiliates: IconLink,
  admins: IconShieldLock,
  clients: IconBuilding,
  consultancies: IconBuildingCommunity,
  clientHr: IconIdBadge2,
  consultancyAdmins: IconUserCog,
  jobs: IconBriefcase,
  skills: IconTags,
  invoices: IconReceipt,
  payouts: IconCash,
  emails: IconMailForward,
  logs: IconListDetails,
  callQueue: IconPhoneCall,
  addCandidate: IconUserPlus,
  postJob: IconPlus,
  hiringFlows: IconTemplate,
  team: IconUsersGroup,
  kyc: IconId,
  orgKyc: IconBuilding,
} as const;
